import Question from '../Components/Question';

function HasCancer() {
    return Question({
        question: "Does the patient have cancer?",
        answers: [
            {
                link: '/affected',
                text: 'Yes',
                properties: {
                    positive: true,
                    floated: "left"
                }
            },
            {
                link: '/unaffected',
                text: 'No',
                properties: {
                    negative: true,
                    floated: "right"
                }
            }
        ]
    });
}

export default HasCancer;
